import { Group } from '@mantine/core';
import { Icon360View, IconDice, IconDownload, IconEye, IconHeart } from '@sloyd/icons';
import { Button } from '../Button/Button';
import { IModel } from '../ModelCard/ModelCard';
import { Gap, Wrapper } from './ModelActions.style';

export type ModelActionsProps = {
  model: IModel;
};

export function ModelActions(props: ModelActionsProps) {
  const { model } = props;
  const { views, likes } = model;

  return (
    <Wrapper className='ModelActions-wrapper' data-testid='ModelActions-wrapper'>
      <Group className='action-strip'>
        {/* Likes and Views Section */}

        {/* Actions Section */}
        <Group style={{ display: 'flex' }}>
          {/* <Button radius="xl" variant='outline' color='gray' leftSection={<IconShare size={20} />} size='sm'>
            Share
          </Button> */}
          <Button
            radius='xl'
            variant='outline'
            color='gray'
            leftSection={<Icon360View size={20} />}
            size='sm'
          >
            Edit
          </Button>
          <Button
            radius='xl'
            variant='outline'
            color='gray'
            leftSection={<IconDownload size={20} />}
            size='sm'
          >
            Export
          </Button>
          <Gap />
          <Button
            radius='xl'
            variant='gradient'
            size='sm'
            gradient={{ from: 'pink', to: 'yellow' }}
            leftSection={<IconDice size={20} />}
            color='blue'
          >
            Randomize
          </Button>
        </Group>

        <Group gap='xs'>
          <Button radius='xl' variant='subtle' color='pink' leftSection={<IconHeart size={20} />}>
            {likes} Likes
          </Button>
          <Button radius='xl' variant='subtle' color='gray' leftSection={<IconEye size={20} />}>
            {views} Views
          </Button>
        </Group>
      </Group>
    </Wrapper>
  );
}

export default ModelActions;
